<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-currency-table ref="table" :items.sync="values" :title="title" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {Currency} from "@/modules/redactor/models/currency/Currency";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table";


export default {
  name: "r-currency-panel",
  components: {RPanel, RCurrencyTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Money"),
    items: VueTypes.arrayOf(Currency)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
